import { MeasureLingette } from '../../domain/Lingette/measure-lingette';
import { mapper } from '../../tools/mapping/mapper';
import { MesureAdduction } from '../../domain/Adduction-air/mesure-adduction';
import { MesureAdductionEntity } from '../entity';
import type { AppDB } from '../db';

export class MeasureAdductionRepository {
    constructor(private readonly database: AppDB) {}


    async getMesureAdductionEntityByCode(code: string) {
        return await this.database.measureAdduction.where('Code').equals(code).first(async mle => {
            return mle;
        });
    }

    async getMesureAdductionEntityById(id: number) {
        return await this.database.measureAdduction.where('Id').equals(id).first(async mle => {
            // const ml = mapper.map(mle, MesureAdductionEntity, MesureAdduction);
            return mle;
        });
    }

    async getMesureAdductionByCodeWithChildren(code: string) {
        return await this.database.measureAdduction.where('Code').equals(code).first(async mae => {
            const ma = mapper.map(mae, MesureAdductionEntity, MesureAdduction);
            if (mae?.MaterielAdductionIds) {
                for (let i = 0; i < mae?.MaterielAdductionIds.length; i++) {
                    ma.MaterielAdductionAirList.push(await this.database.getMaterielAdductionById(mae?.MaterielAdductionIds[i]));
                }
            }

            if (mae?.PrelevementAirIds) {
                for (let i = 0; i < mae?.PrelevementAirIds.length; i++) {
                    ma.PrelevementAirList.push(await this.database.getPrelevementAirById(mae?.PrelevementAirIds[i]));
                }
            }

            return ma;
        });
    }

    async getMesureAdductionByIdWithChildren(id: number) {
        return await this.database.measureAdduction.where('Id').equals(id).first(async mae => {
            const ma = mapper.map(mae, MesureAdductionEntity, MesureAdduction);
            if (mae?.MaterielAdductionIds) {
                for (let i = 0; i < mae?.MaterielAdductionIds.length; i++) {
                    ma.MaterielAdductionAirList.push(await this.database.getMaterielAdductionById(mae?.MaterielAdductionIds[i]));
                }
            }

            if (mae?.PrelevementAirIds) {
                for (let i = 0; i < mae?.PrelevementAirIds.length; i++) {
                    ma.PrelevementAirList.push(await this.database.getPrelevementAirById(mae?.PrelevementAirIds[i]));
                }
            }

            return ma;
        });
    }

    async attachMesureAdduction(measure: MesureAdduction, interventionId: number) {
        let adductionId: number;
        const mme = mapper.map(measure, MesureAdduction, MesureAdductionEntity);

        const ie = await this.database.getInterventionEntityById(interventionId);
        adductionId = await this.database.measureAdduction.add(mme);
        await this.database.interventions.update(interventionId, {
            AdductionIds: ie?.AdductionIds ? [...ie.AdductionIds, adductionId] : [adductionId]
        });

        if (measure.MaterielAdductionAirList) {
            for (let i = 0; i < measure.MaterielAdductionAirList.length; i++) {
                await this.database.attachMaterielAdduction(measure.MaterielAdductionAirList[i], adductionId);
            }
        }

        if (measure.PrelevementAirList) {
            for (let i = 0; i < measure.PrelevementAirList.length; i++) {
                await this.database.attachPrelevementAir(measure.PrelevementAirList[i], adductionId);
            }
        }

        return adductionId;
    }

    async updateMeasureAdduction(measure: MesureAdduction) {
        const mae = await this.database.getMesureAdductionEntityByCode(measure.Code);
        if (!mae || !mae.Id) {
            return false;
        }
        mapper.mutate(measure, mae, MesureAdduction, MesureAdductionEntity);

        if (mae.MaterielAdductionIds)
            await this.database.clearMaterielAdductionById(mae.MaterielAdductionIds);
        if (mae.PrelevementAirIds)
            await this.database.clearPrelevementAirById(mae.PrelevementAirIds);

        mae.MaterielAdductionIds = [];
        mae.PrelevementAirIds = [];
        await this.database.measureAdduction.update(mae.Id, mae);

        if (measure.MaterielAdductionAirList) {
            for (let i = 0; i < measure.MaterielAdductionAirList.length; i++) {
                await this.database.attachMaterielAdduction(measure.MaterielAdductionAirList[i], mae.Id);
            }
        }

        if (measure.PrelevementAirList) {
            for (let i = 0; i < measure.PrelevementAirList.length; i++) {
                await this.database.attachPrelevementAir(measure.PrelevementAirList[i], mae.Id);
            }
        }
        return true;
    }

    async cancelAdduction(measure: MesureAdduction, reason: string) {
        const mle = await this.database.getMesureAdductionEntityByCode(measure.Code);
        if (!mle || !mle.Id) {
            return;
        }

        await this.database.measureAdduction.update(mle.Id, { IsCancelled: true, Observation: reason });
        return true;
    }
}
